import { useEffect, useState } from "react";
import { CircularProgress, Backdrop, Grid, Box } from "@mui/material";
import * as c from '../../../../constants';
import { useAuth } from "../../../../provider";
import axios from "axios";
import SectionLabvisitGroups from "../../../../components/Section/SectionLabvisitGroups";
import MarkerCard from "../ReuseComps/MarkerCard";
import SelectInputNew from "../../../../components/Forms/SelectInputNew";
import { Formik, Form } from 'formik';
import { useTheme } from '@mui/material';

const arterio = ["Lpa", "Ins", "Qu", "Hom", "Q10", "TGI", "EAG", "AIP"]
const hormones = ["Lut","Fol", "E2h", "Test", "Testf", "TestE2", "P4", "Prol", "Shbg", "Dhea" ]
const bones = ["Ctx", "Pth", "Ost"]
const vitamins = ["B9", "K1", "K2", "A", "E", "Caro", "C", "B1", "B2", "B6", "B7", "B12", "D3", "Zinc", "Cu", "Se"]
const thyroid = ["Tsh", "T3", "T4", "Calcit"]

const markerGroups = [
  { name: "ARTERIOSCLEROSIS PREVENTION", list: arterio },
  { name: "HORMONES BALANCE", list: hormones },
  { name: "BONES HEALTH", list: bones },
  { name: "VITAMINS, NUTRIENTS", list: vitamins },
  { name: "THYROID FUNCTION", list: thyroid }
];



export default function SelectDateAddons() {

  const { state } = useAuth();
  const theme = useTheme()

  // selects all measurements of a user
  const url_dates = `${c.API_URL}/users/${state.user.id}/lab-visit-dates/`
  const url_cycle = `${c.API_URL}/api/cycles/by-date/`; 

 // final request becomes: url_cycle + ?target_date=YYYY-MM-DD
  const [measurements, setMeasurements] = useState([]);
  const [dates, setDates] = useState([]);
  const [latestDate, setLatestDate] = useState(null);

  // MUST be declared before using it
  const [selectedDate, setSelectedDate] = useState(null);
  // Now safe to reference selectedDate
  const [localSelected, setLocalSelected] = useState(null);

  const [cycleDay, setCycleDay] = useState(null);
  const [cyclePhase, setCyclePhase] = useState(null);

  const [open, setOpen] = useState(false);
  const [initialLoading, setInitialLoading] = useState(true);

  
// -------------------------------------------------------------
  // FETCH LIST OF VISIT DATES (RUNS ONCE)
  // -------------------------------------------------------------
  useEffect(() => {
    const fetchDates = async () => {
      try {
        const res = await axios.get(url_dates);
        const data = res.data;

        if (Array.isArray(data)) {
          const sortedDates = data
            .map((d) => d.date)
            .sort((a, b) => new Date(b) - new Date(a));   // newest first

          setDates(sortedDates);
          setLatestDate(sortedDates[0]);
          setSelectedDate(sortedDates[0]);   // AUTO-SELECT newest
          setLocalSelected(sortedDates[0]);
          setOpen(true);
        } else {
          console.error("API did not return an array:", data);
        }
      } catch (err) {
        console.error("Failed to fetch lab visit dates:", err);
      } finally {
        setInitialLoading(false);
      }
    };

    fetchDates();
  }, []);  // IMPORTANT: no infinite loop


 // -------------------------------------------------------------
  // FETCH CYCLE INFO WHEN SELECTED DATE CHANGES
  // -------------------------------------------------------------
  useEffect(() => {
    if (!selectedDate) return;
    if (state.user.gender == 'M') return

    const fetchCycleData = async () => {
      try {
        const res = await axios.get(
          `${url_cycle}?target_date=${selectedDate}`
        );

        const d = res.data;
        setCycleDay(d.cycle_day || null);
        setCyclePhase(d.cycle_phase || null);
      } catch (err) {
        console.error("Cycle API error:", err);
        setCycleDay(null);
        setCyclePhase(null);
      }
    };

    fetchCycleData();
  }, [selectedDate]);


  const handleChange = value => {
    setLocalSelected(value);
    handleDateSelect(value);
  };

  const handleDateSelect = date => {
    setSelectedDate(date);
    setOpen(false);
  };

return (
<>   
   <Grid container sx={{mb:4, display: "flex", justifyContent: "center", alignItems:'flex-start' }}>

    {/* FIRST API CALL SPINNER */}
      <Backdrop
        open={initialLoading}
        sx={{ color: "grey.C200", zIndex: (theme) => theme.zIndex.drawer + 1 }}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

    {/* Select Labvisit Date */}
      <Grid size={12} sx={{display: "flex", justifyContent: "center", alignItems:'flex-start' }}>
        <Box width={200}>
            <Formik initialValues={{ selectedDate: latestDate || "",}}>
                {({  }) => (
                <Form style={{ width: "100%" }}>
                    <SelectInputNew
                        name="selectedDate"
                        label="Select Labvisit Date"
                        options={dates.map(d => ({ label: d, value: d }))}
                    />
                </Form>
                )}
            </Formik>
          </Box>   
        </Grid>
    
  {/* BLOODMARKER CARDS */}
 {selectedDate && markerGroups.map((group) => (
  <Grid 
    size={12} 
    key={group.name} 
    sx={{ display: "flex", justifyContent: "center", alignItems: "flex-start" }}
  >
    <SectionLabvisitGroups
      cycleday={cycleDay}
      cyclephase={cyclePhase}
      sectionsubtext={group.name}   // <— dynamic name
      selectedDate={selectedDate}
      markerList={group.list}       // <— marker array
      sectioncards={
        <Grid container spacing={1.4}>
          {group.list.map((markerName) => (
            <Grid 
              size={12}
              key={markerName}
              sx={{ display: "flex", justifyContent: "center" }}
            >
              <MarkerCard 
                markerName={markerName}
                labvisitDate={selectedDate}
              />
            </Grid>
          ))}
        </Grid>
      }
    />
  </Grid>
))}

     
  </Grid>
</>
);
}
